export default "__VITE_ASSET__Bx6zBN2Q__"